import { useTitle } from "../helpers"
import { API_ROUTES } from "../constants/apiRoutes"

export default function Login() {

    useTitle('LMOAPPS - Login')

    return (
        <>

            <div className="conteneur center-block text-center">

                <br />
                <h1>Identification</h1>
                <br />
                <div className="alert alert-danger">Identifiant ou mot de passe incorrect</div>

                <form action={API_ROUTES.LOGIN} method="post">
                    <label htmlFor ="username">Identifiant : </label>
                    <br />
                    <div className="center-marged" style={{maxWidth: "350px"}}>
                        <input type="text" className="form-control" id="username" name="_username" />
                    </div>
                    <br /><br />
                    <label htmlFor="password">Mot de passe : </label>
                    <br />
                    <div className="center-marged" style={{maxWidth: "350px"}}>
                        <input type="password" className="form-control" id="password" name="_password" />
                    </div>
                    <br /><br />
                    <input type="checkbox" id="remember_me" name="_remember_me" defaultChecked={true} />
                    <label htmlFor="_remember_me">Rester connecté </label>
                    <br /><br />


                    <button type="submit" className="btn btn-primary">Connexion</button>
                </form>
            </div>


        </>)
}
